import React from 'react';
import { Phone, MapPin, Facebook } from 'lucide-react';
import { PHONE_TEL, GOOGLE_MAPS_URL, FACEBOOK_URL } from '../constants/business';
export function MobileStickyBar() {
  return <div className="lg:hidden fixed bottom-0 left-0 right-0 bg-brand-hunter text-brand-offwhite z-40 shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.1)] pb-safe" data-id="element-133">
      <div className="flex items-center justify-between px-2 py-2" data-id="element-134">
        <a href={PHONE_TEL} className="flex-1 flex flex-col items-center justify-center py-2 border-r border-brand-offwhite/20" data-id="element-135">
          <Phone className="w-5 h-5 mb-1" data-id="element-136" />
          <span className="text-[10px] font-medium uppercase tracking-wider" data-id="element-137">
            Call
          </span>
        </a>
        <a href={GOOGLE_MAPS_URL} target="_blank" rel="noopener noreferrer" className="flex-1 flex flex-col items-center justify-center py-2 border-r border-brand-offwhite/20" data-id="element-138">
          <MapPin className="w-5 h-5 mb-1" data-id="element-139" />
          <span className="text-[10px] font-medium uppercase tracking-wider" data-id="element-140">
            Directions
          </span>
        </a>
        <a href={FACEBOOK_URL} target="_blank" rel="noopener noreferrer" className="flex-1 flex flex-col items-center justify-center py-2" data-id="element-141">
          <Facebook className="w-5 h-5 mb-1" data-id="element-142" />
          <span className="text-[10px] font-medium uppercase tracking-wider" data-id="element-143">
            Facebook
          </span>
        </a>
      </div>
    </div>;
}